import { Button, DialogBody, DialogFooter, DialogHeader, ResponsiveDialog } from '@/ui_v3';
import { createDialogManager } from '@/ui_v3/components/dialog/utils';
import { type TrialEndQuoteDiscount } from '../utils/quoteCalculator';
type QuoteDiscountAlertProps = {
  discount: TrialEndQuoteDiscount;
  onClose?: (value?: unknown) => void;
};
export const QuoteDiscountAlert = ({
  discount,
  onClose
}: QuoteDiscountAlertProps) => <ResponsiveDialog onClose={onClose} size="sm" className="rounded-md shadow-xl" shouldCloseOnDimClick={false} data-sentry-element="ResponsiveDialog" data-sentry-component="QuoteDiscountAlert" data-sentry-source-file="QuoteDiscountAlert.tsx">
    <DialogHeader title="할인이 적용되지 않은 견적서예요" hasCloseButton className="!px-md !pt-md !text-[19px] !leading-[26.6px]" onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="QuoteDiscountAlert.tsx" />
    <DialogBody data-sentry-element="DialogBody" data-sentry-source-file="QuoteDiscountAlert.tsx">
      <p className="px-md text-body-sm-regular">
        PRO 플랜 {Math.round(discount.discountRate * 100)}% 할인은{' '}
        <strong className="text-body-md-semibold">
          개인 요금제 {discount.maxUserCount}인, 첫 {discount.maxMonthCount}개월
        </strong>
        에 적용돼요.
        <br />
        현재 선택한 조건으로는 할인 혜택을 적용할 수 없어요.
      </p>
    </DialogBody>
    <DialogFooter className="!p-md" data-sentry-element="DialogFooter" data-sentry-source-file="QuoteDiscountAlert.tsx">
      <div className="flex flex-col gap-xs">
        <Button variant="contained" intent="strong" size="md" className="w-full" onClick={() => onClose?.(true)} data-sentry-element="Button" data-sentry-source-file="QuoteDiscountAlert.tsx">
          선택한 조건으로 발행하기
        </Button>
        <Button variant="transparent" intent="neutral" size="md" className="w-full" onClick={() => onClose?.(false)} data-sentry-element="Button" data-sentry-source-file="QuoteDiscountAlert.tsx">
          다시 선택
        </Button>
      </div>
    </DialogFooter>
  </ResponsiveDialog>;
export const quoteDiscountAlert = createDialogManager<QuoteDiscountAlertProps>(options => <QuoteDiscountAlert {...options} />);